/**
 * Apple WeatherKit requires visible attribution wherever its data is shown:
 * the "Weather" trademark plus a link to Apple's data-sources / legal page.
 * https://developer.apple.com/weatherkit/get-started/ (Attribution Requirements)
 */
const LEGAL_ATTRIBUTION_URL = 'https://weatherkit.apple.com/legal-attribution.html'

// Apple logo glyph (U+F8FF) — renders as the  mark on Apple platforms (this is iOS-only).
const APPLE_WEATHER_LABEL = ' Weather'

interface WeatherAttributionProps {
  /** Text color class (defaults to a subtle token). */
  className?: string
}

export function WeatherAttribution({ className = 'text-content-primary-subtle' }: WeatherAttributionProps) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        window.open(LEGAL_ATTRIBUTION_URL, '_blank', 'noopener,noreferrer')
      }}
      className={`text-[10px] leading-3 underline-offset-2 hover:underline self-end ${className}`}
    >
      {APPLE_WEATHER_LABEL}
    </button>
  )
}
